"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvVarName = void 0;
var EnvVarName;
(function (EnvVarName) {
    EnvVarName["DotEnv"] = "DOTENV";
    EnvVarName["PinoPrettyPrint"] = "PINO_PRETTY_PRINT";
    EnvVarName["PinoLogLevel"] = "PINO_LOG_LEVEL";
    EnvVarName["WranggleApiBaseUrl"] = "WRANGGLE_API_BASE_URL";
    EnvVarName["WranggleApiKey"] = "WRANGGLE_API_KEY";
    EnvVarName["WranggleApiSecret"] = "WRANGGLE_API_SECRET";
    EnvVarName["WranggleAccount"] = "WRANGGLE_ACCOUNT";
    EnvVarName["OrganizationUid"] = "WRANGGLE_ACCOUNT";
    EnvVarName["BackendApiBaseUrl"] = "WRANGGLE_API_BASE_URL";
    EnvVarName["AuthorEnvForMain"] = "AUTHOR_ENV_FOR_MAIN";
    EnvVarName["AuthorEnvForPlatform"] = "AUTHOR_ENV_FOR_FANGGLE";
    EnvVarName["HttpsKeyPath"] = "HTTPS_KEY";
    EnvVarName["HttpsCertPath"] = "HTTPS_CERT";
    EnvVarName["HttpsPort"] = "HTTPS_PORT";
    EnvVarName["RedisUrlForUnitTesting"] = "REDIS_URL_FOR_TESTS";
    /**
     * Many/most timeouts in the src are multiplied by this value so code doesn't time out while stepping through code in a debugger. (default 1)
     */
    EnvVarName["TimeMultiplierForDebugger"] = "TIME_MULTIPLIER";
    /**
     * Starts pm2 worker process with node args of --inspect for use with debugger.
     * Only if authorEnv is not main/production, else ignored.
     */
    EnvVarName["WorkerProcNodeDebugger"] = "WORKER_PROC_DEBUGGER";
    /**
     * Does not start pm2 worker processes for taskRunner author code, runs that in same parent.
     * Makes debugger more reliable and can more smoothly step through parent and worker code.
     */
    EnvVarName["SkipWorkerProcSandbox"] = "SKIP_SANDBOX";
})(EnvVarName = exports.EnvVarName || (exports.EnvVarName = {}));
//# sourceMappingURL=env-var-names.js.map